import { Component,OnChanges,Input,OnInit,Output,EventEmitter } from '@angular/core';
import {Router} from "@angular/router"
import { Config } from 'src/assets/configuration/config';
import { ApiService} from '../../share/service/api.service';
declare var jslib;
@Component({
  selector: 'act-select',
  templateUrl: './actSelect.component.html'
})
export class ActSelectComponent implements OnInit {
  constructor(
    public baseApi : ApiService,
    private router: Router
  ) { }

  @Output() ChangeEvt = new EventEmitter();

  public config = Config;
  public Query = {
    main:0,
    select:'',
    name:''
  }
  public LeftMenu;
  public LeftSecMenu;

  ngOnInit() {
    this.SetLeftMenu();
  }

  SetLeftMenu(){
    //設定選單 只保留 0&2項目 即為採購案選單
    var tempSearch = this.config.Search;
    var filter = [];
    tempSearch.forEach(_item => {
      if(_item.value == 0 || _item.value == 2){
        filter.push(_item);
      }
    });
    this.LeftMenu = filter;
    var Selected = this.LeftMenu.find((item)=>{return item.value == this.Query.main})
    this.LeftSecMenu = Selected.SecMenu;
  }
  LeftMenuSet(){
   this.Query.select = '';
   var Selected = this.LeftMenu.find((item)=>{return item.value == this.Query.main});
   this.LeftSecMenu = Selected.SecMenu;
  }
  SearchSubmit(){
    var Selected = this.LeftSecMenu.find((item)=>{return item.value == this.Query.select});
    if(Selected && this.Query.select != ''){
      this.Query.name = Selected.name;
      this.ChangeEvt.emit(this.Query);
    }
  };
}
